import { inject, observer } from "mobx-react";
import * as React from "react";
import { TableauViz } from "./TableauViz";

@inject('stores')
@observer
export default class MissingDispatchFiles extends React.Component {
    public props: any;
    private API: any;
    public state = {
        token: ''
    };

    constructor(props: any) {
        super(props);
        this.API = this.props.stores.Api;
    }

    public componentDidMount(): void {
        this.API.get(`/tableau/gettoken`)
        .then((data : any) => {
            this.setState({
                token: data.token || ''
            });
        });
    }

    public render() {
        return (
            <div>
                <TableauViz 
                    token={this.state.token}
                    src={`https://10ay.online.tableau.com/t/mudmetrix/views/MissingDispatchTicketFiles/MissingDispatchFiles`} 
                />
            </div>

        );
    }
}


// WEBPACK FOOTER //
// ./src/Components/Reporting/Tableau/MissingDispatchFiles.tsx